import {useQuery} from '@tanstack/react-query';
import {QUERY_CACHE_KEYS} from 'utils/constants';
import {useChekinSDK} from 'context/ChekinSDK';
import {CoreError, Guidebook} from '@guestapp/sdk';

type Props = {
  guidebookId?: string;
  reservationId: string;
};
function useFetchGuidebook({guidebookId = '', reservationId}: Props) {
  const {getGuidebook} = useChekinSDK();
  const result = useQuery<Guidebook, CoreError>(
    [QUERY_CACHE_KEYS.guidebook, guidebookId, reservationId],
    () => getGuidebook(guidebookId, reservationId),
    {
      enabled: Boolean(guidebookId && reservationId),
      refetchOnWindowFocus: false,
    },
  );

  return result;
}

export {useFetchGuidebook};
